// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import PaymentMethodsGql from '@/extensions/shop/store/graphql/queries/PaymentMethods.gql';
import PaymentMethodsPaginatedGql from '@/extensions/shop/store/graphql/queries/PaymentMethodsPaginated.gql'
import PaymentMethodGql from '@/extensions/shop/store/graphql/queries/PaymentMethod.gql'
import CreatePaymentMethodGql from '@/extensions/shop/store/graphql/mutations/CreatePaymentMethod.gql';
import UpdatePaymentMethodGql from '@/extensions/shop/store/graphql/mutations/UpdatePaymentMethod.gql';
import DeletePaymentMethodGql from '@/extensions/shop/store/graphql/mutations/DeletePaymentMethod.gql';

export default {
    fetchList: variables =>
        new Promise((resolve, reject) => {
            if (variables.shop) variables.shop = parseInt(variables.shop);

            apolloClient
                .query({
                    query: PaymentMethodsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_PaymentMethods))
                .catch(err => reject(err));
        }),

    fetchPaymentMethodsPaginated: (data, shopID, cmsID) => new Promise((resolve, reject) => {
        let filters = []
        _.each(data.filters, entry => filters.push(entry))

        apolloClient.query({
            query: PaymentMethodsPaginatedGql,
            variables: {
                currentPage: _.get(data, 'pageInfo.currentPage', 1),
                perPage: _.get(data, 'pageInfo.perPage', 25),
                order: _.get(data, 'variables.order', 'id'),
                direction: _.get(data, 'variables.direction', 'asc'),
                shop: parseInt(shopID),
                cms: cmsID ? parseInt(cmsID) : null,
                filters
            }
        })
            .then(({ data }) => resolve(data.CO_PaymentMethodsPaginated))
            .catch(err => reject(err))
    }),
    fetchPaymentMethod: (id) => new Promise((resolve, reject) => {
        apolloClient.query({
            query: PaymentMethodGql,
            variables: {
                id: parseInt(id)
            }
        })
            .then(({ data }) => resolve(data.CO_PaymentMethod))
            .catch(err => reject(err))
    }),
    create: paymentMethod => {
        if (paymentMethod === undefined) throw new Error('required argument is missing')

        paymentMethod = _.removeDeepByKey(paymentMethod, '__typename')
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: CreatePaymentMethodGql,
                variables: { paymentMethod }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_CreatePaymentMethod)
                })
                .catch(err => reject(err))
        })
    },
    update: paymentMethod => {
        if (paymentMethod === undefined) throw new Error('required argument is missing')

        paymentMethod = _.removeDeepByKey(paymentMethod, '__typename')
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: UpdatePaymentMethodGql,
                variables: { paymentMethod }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_UpdatePaymentMethod)
                })
                .catch(err => reject(err))
        })
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing')

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: DeletePaymentMethodGql,
                variables: { id }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_DeletePaymentMethod)
                })
                .catch(err => reject(err))
        })
    },
};
